// import React from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   Grid,
//   Paper,
//   Chip,
//   Button,
//   Stack,
//   Avatar,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";
// import PageBanner from "../components/PageBanner";
// import {
//   RocketLaunch,
//   Restaurant,
//   QrCode2,
//   People,
//   Star,
//   EmojiEmotions,
//   Speed,
//   Security,
//   Support,
//   TrendingUp,
//   Info as InfoIcon,
// } from "@mui/icons-material";
// import CallToAction from "../components/CallToAction";
// const About = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const values = [
//     {
//       icon: <EmojiEmotions sx={{ fontSize: 40 }} />,
//       title: "Customer First",
//       desc: "We prioritize customer experience in everything we do",
//     },
//     {
//       icon: <Speed sx={{ fontSize: 40 }} />,
//       title: "Speed & Efficiency",
//       desc: "Fast ordering and real-time management",
//     },
//     {
//       icon: <Security sx={{ fontSize: 40 }} />,
//       title: "Trust & Security",
//       desc: "Secure payments and data protection",
//     },
//     {
//       icon: <Support sx={{ fontSize: 40 }} />,
//       title: "24/7 Support",
//       desc: "Always here to help our restaurant partners",
//     },
//   ];

//   const stats = [
//     { value: "500+", label: "Restaurants", icon: <Restaurant /> },
//     { value: "10K+", label: "Daily Orders", icon: <TrendingUp /> },
//     { value: "4.8⭐", label: "Average Rating", icon: <Star /> },
//     { value: "98%", label: "Satisfaction Rate", icon: <People /> },
//   ];

//   const team = [
//     { name: "Pooja Saini", role: "Founder & CEO", img: "" },
//     { name: "Sanjeev Kumar", role: "CTO", img: "" },
//     { name: "Kritika Mishra", role: "Head of Operations", img: "" },
//     { name: "Abhilash Kumar", role: "Customer Success", img: "" },
//   ];

//   return (
//     <>
//       <Navbar />

//       {/* Page Banner */}
//       {/* <PageBanner
//         title="Empowering Food Businesses to Go Digital"
//         subtitle="RestaurantWala is a complete QR-based ordering and management platform designed to help restaurants, cafes, and food businesses digitize their operations."
//         chipLabel="ABOUT US"
//         icon={<InfoIcon sx={{ fontSize: { xs: 32, md: 40 }, color: "#fff" }} />}
//       /> */}
//       <PageBanner
//         title="Empowering Food Businesses to Go Digital"
//         subtitle="RestaurantWala is a complete QR-based ordering and management platform"
//         chipLabel="ABOUT US"
//         bgImage="https://images.unsplash.com/photo-1528605248644-14dd04022da1?q=80&w=2070&auto=format&fit=crop"
//       />

//       <Box sx={{ bgcolor: "#ffffff", py: { xs: 6, md: 10 } }}>
//         <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
//           {/* Our Story */}
//           <Paper
//             elevation={0}
//             sx={{
//               p: { xs: 3, sm: 4, md: 5 },
//               borderRadius: "24px",
//               bgcolor: "var(--bg-light)",
//               mb: { xs: 4, md: 6 },
//               border: "1px solid var(--border)",
//             }}
//           >
//             <Grid container spacing={4} alignItems="center">
//               <Grid item size={{ xs: 12, md: 6 }}>
//                 <Typography
//                   sx={{
//                     fontWeight: 800,
//                     fontSize: { xs: "1.5rem", md: "2rem" },
//                     color: "var(--text)",
//                     mb: 2,
//                   }}
//                 >
//                   Our Story
//                 </Typography>
//                 <Typography
//                   sx={{
//                     color: "var(--text-light)",
//                     fontSize: { xs: "15px", md: "16px" },
//                     lineHeight: 1.8,
//                     mb: 2,
//                   }}
//                 >
//                   RestaurantWala was founded in 2024 with a simple mission: to
//                   make restaurant management easy, affordable, and digital.
//                 </Typography>
//                 <Typography
//                   sx={{
//                     color: "var(--text-light)",
//                     fontSize: { xs: "15px", md: "16px" },
//                     lineHeight: 1.8,
//                   }}
//                 >
//                   We saw that small and medium restaurants struggled with
//                   digitization due to high costs and complexity. We built
//                   RestaurantWala to solve this - affordable, easy to use, and
//                   powerful enough to handle all restaurant needs.
//                 </Typography>
//               </Grid>
//               <Grid item size={{ xs: 12, md: 6 }}>
//                 <Box
//                   sx={{
//                     background:
//                       "linear-gradient(135deg, var(--primary-dark), var(--primary))",
//                     borderRadius: "20px",
//                     p: 4,
//                     color: "#fff",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Typography sx={{ fontSize: "3rem", mb: 1 }}>🎯</Typography>
//                   <Typography
//                     sx={{ fontWeight: 700, fontSize: "1.2rem", mb: 1 }}
//                   >
//                     Our Mission
//                   </Typography>
//                   <Typography sx={{ fontSize: "0.95rem", opacity: 0.9 }}>
//                     To empower every restaurant with affordable technology that
//                     simplifies operations, increases revenue, and delights
//                     customers.
//                   </Typography>
//                 </Box>
//               </Grid>
//             </Grid>
//           </Paper>

//           {/* Stats */}
//           <Grid container spacing={3} sx={{ mb: { xs: 4, md: 6 } }}>
//             {stats.map((stat, index) => (
//               <Grid item size={{ xs: 6, sm: 3 }} key={index}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 3,
//                     borderRadius: "16px",
//                     textAlign: "center",
//                     bgcolor: "#ffffff",
//                     border: "1px solid var(--border)",
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                       transform: "translateY(-5px)",
//                       boxShadow: "var(--shadow-orange)",
//                       borderColor: "var(--primary)",
//                     },
//                   }}
//                 >
//                   <Box sx={{ color: "var(--primary)", fontSize: 30, mb: 1 }}>
//                     {stat.icon}
//                   </Box>
//                   <Typography
//                     sx={{
//                       fontWeight: 900,
//                       fontSize: { xs: "1.5rem", md: "2rem" },
//                       color: "var(--text)",
//                     }}
//                   >
//                     {stat.value}
//                   </Typography>
//                   <Typography
//                     sx={{ color: "var(--text-light)", fontSize: "14px" }}
//                   >
//                     {stat.label}
//                   </Typography>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>

//           {/* Our Values */}
//           <Box sx={{ mb: { xs: 4, md: 6 } }}>
//             <Typography
//               sx={{
//                 textAlign: "center",
//                 fontWeight: 800,
//                 fontSize: { xs: "1.8rem", md: "2.5rem" },
//                 color: "var(--text)",
//                 mb: 1,
//               }}
//             >
//               Our{" "}
//               <Box component="span" sx={{ color: "var(--primary)" }}>
//                 Values
//               </Box>
//             </Typography>
//             <Typography
//               sx={{
//                 textAlign: "center",
//                 color: "var(--text-light)",
//                 mb: 4,
//               }}
//             >
//               The principles that guide us every day
//             </Typography>

//             <Grid container spacing={3}>
//               {values.map((value, index) => (
//                 <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={index}>
//                   <Paper
//                     elevation={0}
//                     sx={{
//                       p: 3,
//                       borderRadius: "16px",
//                       textAlign: "center",
//                       bgcolor: "#ffffff",
//                       border: "1px solid var(--border)",
//                       height: "100%",
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         transform: "translateY(-8px)",
//                         boxShadow: "var(--shadow-orange)",
//                         borderColor: "var(--primary)",
//                       },
//                     }}
//                   >
//                     <Box sx={{ color: "var(--primary)", mb: 2 }}>
//                       {value.icon}
//                     </Box>
//                     <Typography
//                       sx={{
//                         fontWeight: 700,
//                         fontSize: "1.1rem",
//                         color: "var(--text)",
//                         mb: 1,
//                       }}
//                     >
//                       {value.title}
//                     </Typography>
//                     <Typography
//                       sx={{ color: "var(--text-light)", fontSize: "14px" }}
//                     >
//                       {value.desc}
//                     </Typography>
//                   </Paper>
//                 </Grid>
//               ))}
//             </Grid>
//           </Box>

//           {/* Team Section */}
//           <Box sx={{ mb: { xs: 4, md: 6 } }}>
//             <Typography
//               sx={{
//                 textAlign: "center",
//                 fontWeight: 800,
//                 fontSize: { xs: "1.8rem", md: "2.5rem" },
//                 color: "var(--text)",
//                 mb: 1,
//               }}
//             >
//               Meet the People Behind {" "}
//               <Box component="span" sx={{ color: "var(--primary)" }}>
//                 RestaurantWala
//               </Box>
//             </Typography>
//             <Typography
//               sx={{
//                 textAlign: "center",
//                 color: "var(--text-light)",
//                 mb: 4,
//               }}
//             >
//               The passionate people behind RestaurantWala
//             </Typography>

//             <Grid container spacing={3}>
//               {team?.map((member, index) => (
//                 <Grid item size={{ xs: 6, sm: 3 }} key={index}>
//                   <Paper
//                     elevation={0}
//                     sx={{
//                       p: 3,
//                       borderRadius: "16px",
//                       textAlign: "center",
//                       bgcolor: "#ffffff",
//                       border: "1px solid var(--border)",
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         transform: "translateY(-8px)",
//                         boxShadow: "var(--shadow-orange)",
//                         borderColor: "var(--primary)",
//                       },
//                     }}
//                   >
//                     {/* <Avatar
//                       src={member.name}
//                       alt={member.name}
//                       sx={{
//                         width: 80,
//                         height: 80, 
//                         mx: "auto",
//                         mb: 2,
//                         backgroundColor: "#FF6B00",
//                         fontSize: "1.5rem",
//                         color: "#fff",
//                       }}
//                     /> */}
//                     <Avatar
//                       alt={member.name}
//                       sx={{
//                         width: 80,
//                         height: 80,
//                         mx: "auto",
//                         mb: 2,
//                         backgroundColor: "#FF6B00",
//                         fontSize: "1.5rem",
//                         color: "#fff",
//                       }}
//                     >
//                       {member.name
//                         .split(" ")
//                         .map((word) => word[0])
//                         .slice(0, 2)
//                         .join("")
//                         .toUpperCase()}
//                     </Avatar>
//                     <Typography sx={{ fontWeight: 700, color: "var(--text)" }}>
//                       {member.name}
//                     </Typography>
//                     <Typography
//                       sx={{ color: "var(--text-light)", fontSize: "14px" }}
//                     >
//                       {member.role}
//                     </Typography>
//                   </Paper>
//                 </Grid>
//               ))}
//             </Grid>
//           </Box>

//           {/* CTA Section */}
//           {/* <Paper
//             elevation={0}
//             sx={{
//               p: { xs: 4, md: 6 },
//               borderRadius: "24px",
//               background: "linear-gradient(135deg, var(--primary-dark), var(--primary))",
//               textAlign: "center",
//               boxShadow: "var(--shadow-orange-hover)",
//             }}
//           >
//             <Typography
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "1.8rem", md: "2.5rem" },
//                 color: "#fff",
//                 mb: 2,
//               }}
//             >
//               Ready to Join RestaurantWala?
//             </Typography>
//             <Typography
//               sx={{
//                 color: "rgba(255,255,255,0.9)",
//                 fontSize: { xs: "16px", md: "18px" },
//                 mb: 3,
//               }}
//             >
//               Start your 30-day free trial today
//             </Typography>
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
//               <Button
//                 variant="contained"
//                 sx={{
//                   bgcolor: "#fff",
//                   color: "var(--primary)",
//                   px: 4,
//                   py: 1.5,
//                   borderRadius: "14px",
//                   fontWeight: 700,
//                   "&:hover": {
//                     bgcolor: "#f0f0f0",
//                     transform: "scale(1.05)",
//                   },
//                 }}
//               >
//                 Register Now
//               </Button>
//               <Button
//                 variant="outlined"
//                 sx={{
//                   color: "#fff",
//                   borderColor: "#fff",
//                   px: 4,
//                   py: 1.5,
//                   borderRadius: "14px",
//                   fontWeight: 700,
//                   "&:hover": {
//                     borderColor: "#fff",
//                     bgcolor: "rgba(255,255,255,0.1)",
//                   },
//                 }}
//               >
//                 Learn More
//               </Button>
//             </Stack>
//           </Paper> */}
//         </Container>
//       </Box>
//       <CallToAction />
//       <Footer />
//     </>
//   );
// };

// export default About;


import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Chip,
  Button,
  Stack,
  Avatar,
  useMediaQuery,
  useTheme,
  Divider,
} from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import {
  RocketLaunch,
  Restaurant,
  QrCode2,
  People,
  Star,
  EmojiEmotions,
  Speed,
  Security,
  Support,
  TrendingUp,
  Info as InfoIcon,
  Verified,
  Shield,
  Payments,
  Gavel,
  QrCode,
} from "@mui/icons-material";
import CallToAction from "../components/CallToAction";
import Udyam from "../assets/images/Udyam.png"; 
import PageTitle from "../components/PageTitle";
import AboutUs from "../assets/images/about.avif";

const About = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const values = [
    {
      icon: <EmojiEmotions sx={{ fontSize: 40 }} />,
      title: "Customer First",
      desc: "We prioritize customer experience in everything we do",
    },
    {
      icon: <Speed sx={{ fontSize: 40 }} />,
      title: "Speed & Efficiency",
      desc: "Fast ordering and real-time management",
    },
    {
      icon: <Security sx={{ fontSize: 40 }} />,
      title: "Trust & Security",
      desc: "Secure payments and data protection",
    },
    {
      icon: <Support sx={{ fontSize: 40 }} />,
      title: "24/7 Support",
      desc: "Always here to help our restaurant partners",
    },
  ];

  const stats = [
    { value: "500+", label: "Restaurants", icon: <Restaurant /> },
    { value: "10K+", label: "Daily Orders", icon: <TrendingUp /> },
    { value: "4.8⭐", label: "Average Rating", icon: <Star /> },
    { value: "98%", label: "Satisfaction Rate", icon: <People /> },
  ];

  const team = [
    { name: "Pooja Saini", role: "Founder & CEO", img: "" },
    { name: "Sanjeev Kumar", role: "CTO", img: "" },
    { name: "Kritika Mishra", role: "Head of Operations", img: "" },
    { name: "Abhilash Saini", role: "Customer Success", img: "" },
  ];

  // MSME Benefits Data
  const msmeBenefits = [
    {
      icon: <Verified sx={{ fontSize: 32 }} />,
      title: "MSME Registered Business",
      desc: "RestaurantWala is a registered Micro Enterprise under the Government of India's Udyam Registration framework.",
    },
    {
      icon: <Payments sx={{ fontSize: 32 }} />,
      title: "Business Credibility",
      desc: "Our MSME registration demonstrates our commitment to transparent and compliant business operations.",
    },
    {
      icon: <Gavel sx={{ fontSize: 32 }} />,
      title: "Access to MSME Benefits",
      desc: "As a registered Micro Enterprise, RestaurantWala may be eligible for various government schemes, benefits, and financial support available to MSMEs, subject to applicable rules and eligibility.",
    },
    {
      icon: <Shield sx={{ fontSize: 32 }} />,
      title: "Government Opportunities",
      desc: "Our MSME registration enables us to explore eligible government procurement opportunities and participate in applicable tenders, subject to tender-specific requirements.",
    },
  ];

  return (
    <>
    <PageTitle
        title="About RestaurantWala – Smart Restaurant Software"
        description="Learn about RestaurantWala, a smart restaurant management platform designed to simplify restaurant operations, improve efficiency and help businesses grow."
        keywords="about RestaurantWala, restaurant management software, restaurant technology, restaurant software India"
      />
      <Navbar />
      <PageBanner
        title="Empowering Food Businesses to Go Digital"
        subtitle="RestaurantWala is a complete QR-based ordering and management platform"
        chipLabel="ABOUT US"
        bgImage={AboutUs}
        // https://images.unsplash.com/photo-1528605248644-14dd04022da1?q=80&w=2070&auto=format&fit=crop
      />

      <Box sx={{ bgcolor: "#ffffff", py: { xs: 6, md: 10 } }}>
        <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
          {/* Our Story */}
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, sm: 4, md: 5 },
              borderRadius: "24px",
              bgcolor: "var(--bg-light)",
              mb: { xs: 4, md: 6 },
              border: "1px solid var(--border)",
            }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid item size={{ xs: 12, md: 6 }}>
                <Typography
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: "1.5rem", md: "2rem" },
                    color: "var(--text)",
                    mb: 2,
                  }}
                >
                  Our Story
                </Typography>
                <Typography
                  sx={{
                    color: "var(--text-light)",
                    fontSize: { xs: "15px", md: "16px" },
                    lineHeight: 1.8,
                    mb: 2,
                  }}
                >
                  RestaurantWala was founded in 2026 with a simple mission: to
                  make restaurant management easy, affordable, and digital.
                </Typography>
                <Typography
                  sx={{
                    color: "var(--text-light)",
                    fontSize: { xs: "15px", md: "16px" },
                    lineHeight: 1.8,
                  }}
                >
                  We saw that small and medium restaurants struggled with
                  digitization due to high costs and complexity. We built
                  RestaurantWala to solve this - affordable, easy to use, and
                  powerful enough to handle all restaurant needs.
                </Typography>
              </Grid>
              <Grid item size={{ xs: 12, md: 6 }}>
                <Box
                  sx={{
                    background:
                      "linear-gradient(135deg, var(--primary-dark), var(--primary))",
                    borderRadius: "20px",
                    p: 4,
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  <Typography sx={{ fontSize: "3rem", mb: 1 }}>🎯</Typography>
                  <Typography
                    sx={{ fontWeight: 700, fontSize: "1.2rem", mb: 1 }}
                  >
                    Our Mission
                  </Typography>
                  <Typography sx={{ fontSize: "0.95rem", opacity: 0.9 }}>
                    To empower every restaurant with affordable technology that
                    simplifies operations, increases revenue, and delights
                    customers.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Paper>

          {/* Stats */}
          {/* <Grid container spacing={3} sx={{ mb: { xs: 4, md: 6 } }}>
            {stats.map((stat, index) => (
              <Grid item size={{ xs: 6, sm: 3 }} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    borderRadius: "16px",
                    textAlign: "center",
                    bgcolor: "#ffffff",
                    border: "1px solid var(--border)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "var(--shadow-orange)",
                      borderColor: "var(--primary)",
                    },
                  }}
                >
                  <Box sx={{ color: "var(--primary)", fontSize: 30, mb: 1 }}>
                    {stat.icon}
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: 900,
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      color: "var(--text)",
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    sx={{ color: "var(--text-light)", fontSize: "14px" }}
                  >
                    {stat.label}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid> */}

          {/* ============================================ */}
          {/* ✅ NEW: MSME SECTION - ADDED HERE */}
          {/* ============================================ */}
          <Box sx={{ mb: { xs: 4, md: 6 } }}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, sm: 4, md: 5 },
                borderRadius: "24px",
                border: "2px solid #FF6B00",
                background:
                  "linear-gradient(135deg, #fff8f0 0%, #ffffff 100%)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Decorative Badge */}
              <Box
                sx={{
                  position: "absolute",
                  top: 20,
                  right: 20,
                  bgcolor: "#FF6B00",
                  color: "#fff",
                  px: 2,
                  py: 0.5,
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Verified sx={{ fontSize: 16 }} />
                UDYAM REGISTERED
              </Box>

              <Box sx={{ textAlign: "center", mb: 4, mt:2 }}>
                <Typography
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: "1.5rem", md: "2.3rem" },
                    color: "var(--text)",
                    mb: 1,
                  }}
                >
                  Proudly{" "}
                  <Box component="span" sx={{ color: "var(--primary)" }}>
                    MSME (Udyam)
                  </Box>{" "}
                  Registered Enterprise
                </Typography>
                <Typography
                  sx={{
                    color: "var(--text-light)",
                    maxWidth: "700px",
                    mx: "auto",
                    fontSize: "16px",
                  }}
                >
                  RestaurantWala is officially registered under the Government of India's Udyam Registration scheme. Our registration reflects our commitment to operating as a transparent and compliant business.
                </Typography>
              </Box>

              {/* MSME Benefits Grid */}
              <Grid container spacing={3} sx={{ mb: 3 }}>
                {msmeBenefits.map((benefit, index) => (
                  <Grid item size={{ xs: 12, md: 6 }} key={index}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: "16px",
                        bgcolor: "#ffffff",
                        border: "1px solid var(--border)",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                        height: "100%",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "var(--shadow-orange)",
                          borderColor: "var(--primary)",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          color: "var(--primary)",
                          bgcolor: "#fff0e6",
                          p: 1.5,
                          borderRadius: "12px",
                          minWidth: 56,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {benefit.icon}
                      </Box>
                      <Box>
                        <Typography
                          sx={{ fontWeight: 700, color: "var(--text)", mb: 0.5 }}
                        >
                          {benefit.title}
                        </Typography>
                        <Typography
                          sx={{ color: "var(--text-light)", fontSize: "14px" }}
                        >
                          {benefit.desc}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>

              {/* Udyam Details Card */}
              {/* <Paper
                elevation={0}
                sx={{
                  p: { xs: 3, md: 4 },
                  borderRadius: "16px",
                  bgcolor: "#f5f5f5",
                  border: "1px dashed var(--primary)",
                  mt: 2,
                }}
              >
                <Grid container spacing={3} alignItems="center">
                  <Grid item size={{ xs: 12, md: 8 }}>
                    <Stack spacing={1}>
                      <Typography sx={{ fontWeight: 700, color: "var(--text)" }}>
                         Udyam Registration Details
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
                        <Box>
                          <Typography sx={{ fontSize: "13px", color: "var(--text-light)" }}>
                            Registration No.
                          </Typography>
                          <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                            UDYAM-RJ-21-0099550
                          </Typography>
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: "13px", color: "var(--text-light)" }}>
                            Registration Date
                          </Typography>
                          <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                            02/09/2026
                          </Typography>
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: "13px", color: "var(--text-light)" }}>
                            Category
                          </Typography>
                          <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                            Micro Enterprise (Services)
                          </Typography>
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: "13px", color: "var(--text-light)" }}>
                            NIC Code
                          </Typography>
                          <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                            62011 - Computer Programming
                          </Typography>
                        </Box>
                      </Box>
                    </Stack>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 4 }} sx={{ textAlign: "center" }}>
                    <Box
                      sx={{
                        bgcolor: "#fff",
                        p: 2,
                        borderRadius: "12px",
                        display: "inline-block",
                        border: "1px solid var(--border)",
                      }}
                    >
                      <img
                        src={Udyam}
                        alt="Udyam QR Code"
                        style={{ width: 74, height: 74 }}
                      />
                      <Typography sx={{ fontSize: "12px", color: "var(--text-light)", mt: 1 }}>
                        Scan to Verify on Govt. Portal
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Paper> */}

              {/* Trust Badge */}
              <Box sx={{ textAlign: "center", mt: 3 }}>
                <Chip
                  icon={<Shield sx={{ fontSize: 18 }} />}
                  label="Trusted. Transparent. Government Verified."
                  sx={{
                    bgcolor: "var(--primary)",
                    color: "#fff",
                    fontWeight: 600,
                    px: 1,
                    "& .MuiChip-icon": { color: "#fff" },
                  }}
                />
              </Box>
            </Paper>
          </Box>
          {/* ============================================ */}
          {/* ✅ END OF MSME SECTION */}
          {/* ============================================ */}

          {/* Our Values */}
          <Box sx={{ mb: { xs: 4, md: 6 } }}>
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: 800,
                fontSize: { xs: "1.8rem", md: "2.5rem" },
                color: "var(--text)",
                mb: 1,
              }}
            >
              Our{" "}
              <Box component="span" sx={{ color: "var(--primary)" }}>
                Values
              </Box>
            </Typography>
            <Typography
              sx={{
                textAlign: "center",
                color: "var(--text-light)",
                mb: 4,
              }}
            >
              The principles that guide us every day
            </Typography>

            <Grid container spacing={3}>
              {values.map((value, index) => (
                <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      borderRadius: "16px",
                      textAlign: "center",
                      bgcolor: "#ffffff",
                      border: "1px solid var(--border)",
                      height: "100%",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "var(--shadow-orange)",
                        borderColor: "var(--primary)",
                      },
                    }}
                  >
                    <Box sx={{ color: "var(--primary)", mb: 2 }}>
                      {value.icon}
                    </Box>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "1.1rem",
                        color: "var(--text)",
                        mb: 1,
                      }}
                    >
                      {value.title}
                    </Typography>
                    <Typography
                      sx={{ color: "var(--text-light)", fontSize: "14px" }}
                    >
                      {value.desc}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Team Section */}
          <Box sx={{ mb: { xs: 4, md: 6 } }}>
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: 800,
                fontSize: { xs: "1.8rem", md: "2.5rem" },
                color: "var(--text)",
                mb: 1,
              }}
            >
              Meet the People Behind{" "}
              <Box component="span" sx={{ color: "var(--primary)" }}>
                RestaurantWala
              </Box>
            </Typography>
            <Typography
              sx={{
                textAlign: "center",
                color: "var(--text-light)",
                mb: 4,
              }}
            >
              The passionate people behind RestaurantWala
            </Typography>

            <Grid container spacing={3}>
              {team?.map((member, index) => (
                <Grid item size={{ xs: 6, sm: 3 }} key={index}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      borderRadius: "16px",
                      textAlign: "center",
                      bgcolor: "#ffffff",
                      border: "1px solid var(--border)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "var(--shadow-orange)",
                        borderColor: "var(--primary)",
                      },
                    }}
                  >
                    <Avatar
                      alt={member.name}
                      sx={{
                        width: 80,
                        height: 80,
                        mx: "auto",
                        mb: 2,
                        backgroundColor: "#FF6B00",
                        fontSize: "1.5rem",
                        color: "#fff",
                      }}
                    >
                      {member.name
                        .split(" ")
                        .map((word) => word[0])
                        .slice(0, 2)
                        .join("")
                        .toUpperCase()}
                    </Avatar>
                    <Typography sx={{ fontWeight: 700, color: "var(--text)" }}>
                      {member.name}
                    </Typography>
                    <Typography
                      sx={{ color: "var(--text-light)", fontSize: "14px" }}
                    >
                      {member.role}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>
      <CallToAction />
      <Footer />
    </>
  );
};

export default About;